import { getDate, getNextWeekwithWeekdays } from "../../basicHelper";


export async function AddClassForNextWeek() {
    const date = getDate(); 
    
    const next7Days = getNextWeekwithWeekdays(date);

    return next7Days;
}